import Splide from '@splidejs/splide';

export const init = () => {
  const carousels = document.querySelectorAll('.carousel_type-14');
  if (carousels.length === 0) return;

  carousels.forEach((carousel) => {
    let splide;

    const initSplide = () => {
      splide = new Splide(carousel, {
        arrows: false,
        pagination: false,
        fixedWidth: 480,
        gap: 32,
        perMove: 1,
        drag: true,
        speed: 1000,
        breakpoints: {
          1055: {
            fixedWidth: 337,
          },
          671: {
            fixedWidth: 296,
          },
        },
      });
      splide.mount();
    };

    const destroySplide = () => {
      if (splide) {
        splide.destroy();
        splide = null;
      }
    };

    const updateImagesHeight = async () => {
      const images = carousel.querySelectorAll('.s-card-slider__item .image img');
      if (images.length === 0) return;

      // Promises to wait for all images to load
      const imagePromises = Array.from(images).map((img) => {
        return new Promise((resolve) => {
          if (img.complete) {
            resolve();
          } else {
            img.onload = resolve;
          }
        });
      });

      // After all images are loaded
      await Promise.all(imagePromises);
      let maxImageHeight = 0;
      // Find the maximum image height
      images.forEach((img) => {
        maxImageHeight = Math.max(maxImageHeight, img.clientHeight);
      });
      // Set the parent element height to the maximum image height
      images.forEach((img) => {
        img.parentElement.style.height = `${maxImageHeight}px`;
      });
    };

    const handleResize = () => {
      const isSmallScreen = window.innerWidth <= 671;
      const itemTexts = carousel.querySelectorAll('.s-card-slider__item .content');
      if (isSmallScreen && itemTexts.length !== 0) {
        destroySplide();
        updateImagesHeight().then(() => {
          itemTexts.forEach((content) => {
            content.previousElementSibling.removeAttribute('style');
            content.parentElement.parentElement.removeAttribute('style');
          });
        });
      } else if (!isSmallScreen && !splide) {
        updateImagesHeight().then(() => {
          initSplide();
        });
      }
    };

    // Initial call to set image heights and init carousel
    updateImagesHeight().then(() => {
      initSplide();
      // Initial check for small screens
      handleResize();
    });

    // Update image heights on window resize
    const resizeListener = () => {
      updateImagesHeight().then(() => {
        handleResize();
      });
    };

    window.addEventListener('resize', resizeListener);
  });
};

// Ensure this script runs after all content is loaded
document.addEventListener('DOMContentLoaded', () => {
  init();
});